module.exports = __webpack_public_path__ + "static/media/icono_puesta_en_escena.eed3791a.svg";